// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__Iv4Mh","loader__logo":"Loader_loader__logo__x6F7U","logo-anim":"Loader_logo-anim__g5DBQ"};